import { createAsyncThunk } from '@reduxjs/toolkit';
import { VehicleProDataService } from '../../../epics/common/commonData';
import {
    brakesStateProKey,
    clearVehicleProKey,
    engineStateProKey,
    interiorStateProKey,
    suspensionStateProKey,
    transmissionStateProKey,
} from '../thunkKeys/vehicleProThunksKeys';
import { clearBrakesState } from '../vehicle_reducers/vehicle_pro/brakesState';
import { clearEngineState } from '../vehicle_reducers/vehicle_pro/engineState';
import { clearInteriorState } from '../vehicle_reducers/vehicle_pro/interiorState';
import { clearSuspensionState } from '../vehicle_reducers/vehicle_pro/suspensionState';
import { clearTransmissionState } from '../vehicle_reducers/vehicle_pro/transmissionState';

export const clearVehicleProDataAction = createAsyncThunk(
    clearVehicleProKey,
    (_, { dispatch }) => {
        dispatch(clearBrakesState());
        dispatch(clearEngineState());
        dispatch(clearInteriorState());
        dispatch(clearSuspensionState());
        dispatch(clearTransmissionState());
    },
);

export const getBrakesState = createAsyncThunk(
    brakesStateProKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleProDataService.getBrakesState();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getEngineState = createAsyncThunk(
    engineStateProKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleProDataService.getEngineState();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getInteriorState = createAsyncThunk(
    interiorStateProKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleProDataService.getInteriorState();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getSuspensionState = createAsyncThunk(
    suspensionStateProKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleProDataService.getSuspensionState();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTransmissionState = createAsyncThunk(
    transmissionStateProKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleProDataService.getTransmissionState();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
